import { Locale, K } from "../constants";

const locale: Locale = {
  [K.LAST_AN_HOUR]: "近1小时",
  [K.LAST_24_HOURS]: "近24小时",
  [K.TODAY]: "今天",
  [K.LAST_7_DAYS]: "近7天",
  [K.LAST_30_DAYS]: "近30天",
  [K.SPECIFIED_RANGE]: "指定范围",
  [K.QUICK_SELECTION]: "快速选择",
  [K.CONFIRM]: "确定",
  [K.START_DATE]: "开始日期",
  [K.END_DATE]: "结束日期",
};

export default locale;
